import Form from '@/components/organisms/Auth/Login/Form'

export function LoginPage() {
	return <Form />
}
